function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.546,2H6.638a.773.773,0,0,1,.758.619l.773,3.865a.773.773,0,0,1-.209.7L6.012,9.127a9.315,9.315,0,0,0,4.321,4.321l1.94-1.948a.773.773,0,0,1,.7-.209l3.865.773a.777.777,0,0,1,.626.758v3.092a1.546,1.546,0,0,1-1.546,1.546H14.369A12.369,12.369,0,0,1,2,5.092V3.546A1.551,1.551,0,0,1,3.546,2Z",
  transform: "translate(-2 -2)"
});

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.461,
    height: 15.461,
    viewBox: "0 0 15.461 15.461"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Phone.b23f85be.svg";
export { SvgPhone as ReactComponent };